import {moduleKeys} from './moduleKeys';

// Default menu pins backfilled for a new user on first login, in the order the
// pinned rail should show them (currently mirrors the sidebar menu). The list
// is independent of the moduleKeys declaration order — reorder it freely to
// change the default rail. Deliberately absent: settings (lives in the top
// bar) and restricted-area (a standalone route, not a menu module).
// Completeness against moduleKeys and the module registration is guarded by
// moduleRegistrationGuards.spec.ts in apps/dms. The sidebar drops any stored
// pin id without a live, accessible menu item (transformPinnedMenuItems), so
// an entry here that a user cannot see is dead data, never a broken sidebar.
export const defaultMenuPins: string[] = [
  moduleKeys.core,
  moduleKeys.sourcing,
  moduleKeys.taskManager,
  moduleKeys.quickPurchase,
  moduleKeys.customers,
  moduleKeys.vehicles,
  moduleKeys.communication,
  moduleKeys.telephony,
  moduleKeys.businessCase,
  moduleKeys.testDrive,
  moduleKeys.auction,
  moduleKeys.rentalOrder,
  moduleKeys.interest,
  moduleKeys.workshop,
  moduleKeys.warehouse,
  moduleKeys.accounting,
  moduleKeys.inspection,
  moduleKeys.analytics,
  moduleKeys.salesLeague,
  moduleKeys.employee,
  moduleKeys.tiresInventory,
  moduleKeys.import,
  moduleKeys.opportunitiesKanban,
  moduleKeys.recordAudit,
  moduleKeys.myProfile,
];
